import React, { CSSProperties, useMemo, useState } from 'react';
import {
  FilterBottomsheetComponents,
  FilterBottomsheetProps,
  FilterButtonProps,
} from './FilterBottomSheet.types';
import { AllieButton } from '../../../components/Buttons/Button';
import { AllieFilterOutlineIcon } from '../../../styling/icons';
import { BottomSheetComponent } from './components/BottomSheetComponent';
import { FilterButtonIconContainerMobileApp } from './FilterBottomSheet.MobileApp.styles';

export const useFilterBottomsheetMobileApp = (): FilterBottomsheetComponents => {
  const [isOpen, setIsOpen] = useState(false);

  const FilterButtonComponent: React.FC<FilterButtonProps> = () => (
    <AllieButton
      allieType="secondary"
      allieSize="none"
      style={
        {
          '--border-width': '0px',
          padding: 6,
          backgroundColor: 'var(--allie-color-neutral-20)',
          borderRadius: 'var(--allie-radius-full)',
          margin: 0,
        } as CSSProperties
      }
      onClick={() => setIsOpen(true)}
    >
      <FilterButtonIconContainerMobileApp>
        <AllieFilterOutlineIcon />
      </FilterButtonIconContainerMobileApp>
    </AllieButton>
  );

  const BottomSheet = useMemo(
    () =>
      ({
        filters,
        onApplyFilters,
        preselectedFilters = {},
        onClose,
        labels,
        onFilterChange,
        showCloseButton,
      }: FilterBottomsheetProps) => (
        <div style={{ '--bottom-sheet-padding-bottom': '65px' } as CSSProperties}>
          <BottomSheetComponent
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            filters={filters}
            onApplyFilters={onApplyFilters}
            onClose={onClose}
            labels={labels}
            preselectedFilters={preselectedFilters}
            onFilterChange={onFilterChange}
            showCloseButton={showCloseButton}
          />
        </div>
      ),
    [isOpen, setIsOpen]
  );

  return { FilterButton: FilterButtonComponent, BottomSheet };
};
